import { featureFlagService } from '../../../utils/feature-flag'

/**
 * マイルストーンの対象WBS項目機能が有効か。
 *
 * このフラグは本番が partial (テナントホワイトリスト) で、判定にログイン中テナントが
 * 必要になる。モジュールスコープで評価するとログイン前の判定が焼き付いてしまうため、
 * 必ず描画時に呼び出すこと。
 */
export const isMilestoneTargetEnabled = (): boolean =>
  featureFlagService.isEnabled('milestone-wbs-item-target')
